import { NTable } from '@innersource-nn/novoui-react';

export interface StackContentProps {
    stack: any;
    resources: any[];
    tableHeaders: any[];
}

export const StackContent = ({
    stack,
    resources,
    tableHeaders,
}: StackContentProps) => {
    return (
        <div>
            <div className="bg-granite-grey-100 rounded-8 p-16 flex flex-col gap-16">
                <div className="flex justify-start gap-24">
                    <div>
                        <b>Name</b>
                        <p>
                            dh-{stack.stackUri}-{stack.stack}
                        </p>
                    </div>
                    <div>
                        <b>Account ID</b>
                        <p>{stack.accountid}</p>
                    </div>
                    <div>
                        <b>Region</b>
                        <p>{stack.region}</p>
                    </div>
                    <div>
                        <b>Status</b>
                        <p>{stack.status}</p>
                    </div>
                </div>
                <div>
                    <b>Arn</b>
                    <p>{stack.stackid}</p>
                </div>
            </div>

            <div>
                {resources && resources.length > 0 && (
                    <div className="mt-16">
                        <b>Name</b>
                        <div className="relative">
                            <NTable
                                headers={tableHeaders}
                                columnBorder={true}
                                items={resources}
                                rowKey="StackId"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
export default StackContent;
